import { FilterIcon, Settings } from 'lucide-react'
import { Filter } from '../../../components/ui/Filter'
import { Select } from '../../../components/ui/Form/Select'
import { Input } from '../../../components/ui/Form/Input'
import { AgendaInteligenteController } from '../../../services/controllers/agendaInteligente'
import { useAgendaInteligente } from '../../../store/agendaInteligente/useAgendaInteligente'

export function AgendaInteligenteFilter() {
  const CAgendaInteligente = AgendaInteligenteController()
  const filter = useAgendaInteligente(st => st.data.filter)
  const isLoading = useAgendaInteligente(st => st.data.isLoading)

  return (
    <Filter.Root onSubmit={e => { e.preventDefault(); CAgendaInteligente.fetchData() }}>
      <Filter.Container>
        <Select.Root
          label="Status do agendamento"
          value={filter.status}
          style={{ maxWidth: 180 }}
          onChange={status => CAgendaInteligente.setFilter({ status })}
        >
          <Select.Option value="todos">Todos</Select.Option>
          <Select.Option value="AGENDADO">Agendados</Select.Option>
          <Select.Option value="CONFIRMADO">Confirmados</Select.Option>
          <Select.Option value="CANCELADO">Cancelados</Select.Option>
        </Select.Root>

        <Select.Root
          label="Tipo"
          value={filter.type}
          style={{ maxWidth: 160 }}
          onChange={type => CAgendaInteligente.setFilter({ type })}
        >
          <Select.Option value="todos">Todos</Select.Option>
          <Select.Option value="avulso">Avulso</Select.Option>
          <Select.Option value="pacote">Pacote</Select.Option>
          <Select.Option value="assinatura">Assinatura</Select.Option>
        </Select.Root>

        <Input.Root
          label="Buscar"
          value={filter.query}
          style={{ maxWidth: 260 }}
          onChange={query => CAgendaInteligente.setFilter({ query })}
          placeholder="Tutor, pet ou serviço…"
        />
      </Filter.Container>

      <Filter.Actions>
        <Filter.Action isLoading={isLoading}>
          <Filter.ActionIcon icon={FilterIcon} isLoading={isLoading} />
          Filtrar
        </Filter.Action>
        <Filter.Action outline type="button" onClick={CAgendaInteligente.clearFilter}>
          Limpar
        </Filter.Action>
        <Filter.Action type="button" onClick={CAgendaInteligente.openSettings}>
          <Filter.ActionIcon icon={Settings} />
        </Filter.Action>
      </Filter.Actions>
    </Filter.Root>
  )
}
